import { v4 } from 'uuid'

export default { uuid: () => v4() }